

//  React base styles
import borders from "assets/theme/base/borders";
import tableDesign from "assets/theme/components/table/tableDesign";

const { borderRadius } = borders;

const tableHead = {
  styleOverrides: {
    root: {
      display: "table-header-group",
      padding: 0,
      borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
      "& th": {
        backgroundColor: tableDesign.headerBackground,
        color: tableDesign.headerColor,
        fontWeight: tableDesign.headerFontWeight,
      },
    },
  },
};

export default tableHead;
